<mat-paginator
	[length]="totalItems()"
	[pageSize]="currentPageSize()"
	[pageIndex]="currentPageIndex()"
	[pageSizeOptions]="availablePageSizes()"
	[showFirstLastButtons]="shouldShowFirstLastButtons()"
	[hidePageSize]="shouldHidePageSize()"
	(page)="emitPageChange($event)"
	aria-label="Seite auswählen"
>
</mat-paginator>
